<template>

    <div v-if="showLottie">

        <lottie
            :options="defaultOptions"
            v-on:animCreated="handleAnimation"
        />

    </div>

</template>

<script>

import Lottie from 'vue-lottie'

export default {

    name: 'lottie-happy-earth',

    components: {Lottie},

    props: {
        active: {
            type: Boolean,
            default: false
        },

        loop: {
            type: Boolean,
            default: false
        },

        autoplay: {
            type: Boolean,
            default: false
        }
    },

    watch: {
        active: function (play) {
            if (play) {
                this.play()
            } else {
                this.stop()
            }
        }
    },

    computed: {
        defaultOptions() {
            return {
                animationData: this.localAnimationData,
                loop: this.loop,
                autoplay: this.autoplay
            }
        }
    },

    data() {
        return {
            anim: null,
            localAnimationData: null,
            showLottie: false
        }
    },

    mounted() {
        this.$http.get('/img/lottie/dexter/morgane.json').then((data) => {
            this.localAnimationData = data.body
            this.showLottie = true
        })
    },

    methods: {

        handleAnimation: function (anim) {
            this.anim = anim
        },

        stop: function () {
            this.anim.stop()
        },

        play: function () {
            this.anim.play()
        },

        pause: function () {
            this.anim.pause()
        },

        onSpeedChange: function () {
            this.anim.setSpeed(this.animationSpeed)
        }
    }

}

</script>

<style lang="scss" scoped></style>
